<div class="px-4 mt-24 min-h-screen">
  <div class="max-w-md w-full mx-auto space-y-6">
    <div class="daisy-card bg-base-100 shadow-xl">
      <div class="daisy-card-body items-center text-center">
        <h2 class="daisy-card-title text-2xl mb-4">Parental Consent</h2>
        
        @if (isLoading) {
          <span class="loading loading-spinner loading-lg text-primary"></span>
          <p class="mt-4 text-base-content/70">Processing your request...</p>
        } @else {
          @if (isSuccess) {
            <div class="text-success mb-4">
              <i class="fa-solid fa-circle-check text-6xl"></i>
            </div>
            <p class="text-lg font-medium">{{ message }}</p>
            <div class="daisy-card-actions mt-6">
              <a routerLink="/auth/login" class="daisy-btn daisy-btn-primary">Go to Login</a>
            </div>
          } @else {
            <div class="text-error mb-4">
              <i class="fa-solid fa-circle-xmark text-6xl"></i>
            </div>
            <p class="text-lg font-medium">{{ message }}</p>
            <div class="daisy-card-actions mt-6">
              <a routerLink="/" class="daisy-btn daisy-btn-outline">Go to Homepage</a>
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>
